import React from "react";
import { History } from "history";
import { Link } from "react-router-dom";

import {
  Alerta,
  TipoAlerta,
  CampoTexto,
  Row,
  Col,
} from "@intechprev/componentes-web";
import { Session } from "@intech/react-service";

import packageJson from "../../../package.json";
import { PageClean } from "../";

import EsqueciSenha from "./EsqueciSenha";
import SelecionarMatricula from "./SelecionarMatricula";
import { LoginEntidade } from "../../entidades";
import { UsuarioService } from "../../services";

export { EsqueciSenha, SelecionarMatricula };

interface Props {
  history?: History;
}

interface State {
  user: LoginEntidade;
  loading: boolean;
  mensagem: string;
  erro: string;
}

export default class Login extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      user: new LoginEntidade(),
      loading: false,
      mensagem: "",
      erro: "",
    };
  }

  onSubmit = async (e: any) => {
    e.preventDefault();

    await this.setState({ loading: true });

    try {
      var login = await UsuarioService.Login(this.state.user);

      await Session.setToken(login.AccessToken);
      await localStorage.setItem(
        "pensionista",
        login.Pensionista.toString()
      );

      var matriculas = await UsuarioService.BuscarMatriculas();

      if (matriculas.length > 1) {
        await this.props.history.push("/selecionarMatricula");
      } else {
        const contratos = await UsuarioService.BuscarContratos();

        if (contratos.length > 1) {
          this.props.history.push("/selecionarContrato");
        }
        else {
          await this.props.history.push("/");
        }
      }
    } catch (erro) {
      if (erro.response) {
        await this.setState({ erro: erro.response.data });
      } else {
        await this.setState({ erro });
      }
    } finally {
      await this.setState({ loading: false });
    }
  };

  render() {
    return (
      <PageClean {...this.props}>
        <h4>Bem vindo ao portal da EQTPREV</h4>

        <h5>
          <b>Área de Acesso Restrito</b>
          <br />
          <small>
            Para informações, entre em contato com a{" "}
            <a href="https://eqtprev.com.br/fale-conosco/">
              EQTPREV
            </a>
          </small>
          <br />
          <br />
        </h5>

        <form>
          <div>
            <CampoTexto
              contexto={this}
              nome={"Cpf"}
              parent={"user"}
              max={11}
              valor={this.state.user.Cpf}
              placeholder={"CPF (somente números)"}
              tipo={"number"}
            />
            <CampoTexto
              contexto={this}
              nome={"Senha"}
              parent={"user"}
              max={64}
              valor={this.state.user.Senha}
              placeholder={"Senha"}
              tipo={"password"}
            />

            <div className="form-group">
              <button
                type="submit"
                id="entrar"
                className="btn btn-block btn-primary"
                onClick={this.onSubmit}
                disabled={this.state.loading}
              >
                {!this.state.loading && <span>Entrar</span>}

                {this.state.loading && (
                  <i className="fas fa-spinner fa-pulse"></i>
                )}
              </button>
            </div>

            {this.state.mensagem !== "" && (
              <Alerta
                tipo={TipoAlerta.info}
                mensagem={this.state.mensagem}
              />
            )}
            {this.state.erro !== "" && (
              <Alerta
                tipo={TipoAlerta.danger}
                mensagem={this.state.erro}
              />
            )}

            <div className="form-group">
              <Link
                className="btn btn-link"
                id="esqueciSenha"
                to="/esqueciSenha"
              >
                Esqueci Minha Senha / Primeiro Acesso
              </Link>
            </div>
          </div>
        </form>

        <br />
        <br />
        <div className="text-center">Versão {packageJson.version}</div>
      </PageClean>
    );
  }
}
